import React, { useState, useEffect, useRef } from 'react';

const AnnouncementBox = () => {
    const listRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false); // Track hover state

    useEffect(() => {
        const interval = setInterval(() => {
            if (listRef.current && !isHovered) { // Only scroll if not hovered
                const scrollHeight = listRef.current.scrollHeight;
                const clientHeight = listRef.current.clientHeight;

                // Check if the bottom of the list is reached
                if (listRef.current.scrollTop + clientHeight >= scrollHeight) {
                    listRef.current.scrollTop = 0; // Reset scroll to the top when it reaches the bottom
                } else {
                    listRef.current.scrollTop += 1; // Scroll down gradually
                }
            }
        }, 30); // Speed of the scrolling (lower is faster)

        return () => clearInterval(interval); // Cleanup on component unmount
    }, [isHovered]); // Re-r) => clearInterval(interval); // Cleanup interval on component unmount


    return (
        <>
            <div className="announcement-box rounded shadow-sm p-3 pt-0 mb-5 bg-white"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)} >
                <div className="announcement-title  text-white text-center p-2 font-weight-bold" style={{ backgroundColor: "#1d3243 " }}>
                    Announcements
                </div>
                <div
                    className="announcement-list"
                    style={{ maxHeight: '200px', overflow: 'hidden', position: 'relative' }}
                    ref={listRef}
                >
                    <ul style={{ listStyleType: "disc" }} className=" p-2 m-0">

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/ICSCSP-2026-June-19-20.jpeg" target="_blank">
                                9th International Conference on Soft Computing and Signal Processing (ICSCSP-2026), to be held on June 19�20, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/ICESBA-2026-Jan-30-31.jpeg" target="_blank">
                                10th International Conference on Emerging Strategies for Business Advancements (ICESBA-2026) on January 30th & 31st, 2026.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/ICTACSE-2026-Jan-30-31.jpeg" target="_blank">
                                10th International Conference on Technical Advancements in Computer Science and Engineering (ICTACSE-2026) to be held on January 30th & 31st, 2026 in Blended Mode.
                            </a>
                        </li>


                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/MEDHA-2K25-IEEE-Nov-8.jpeg" target="_blank">
                                IEEE Student Chapter Presents MEDHA 2K25 � National Level Technical Symposium on 8th November, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/MEDHA-2K25-ISTE-Nov-8.jpeg" target="_blank">
                                ISTE Student Chapter Presents MEDHA 2K25 � National Level Technical Symposium on 8th November, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/MEDHA-2K25-CSI-Nov-8.jpeg" target="_blank">
                                CSI Student Chapter Presents MEDHA 2K25 � National Level Technical Symposium on 8th November, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/TARANG-2K25-Nov-8.jpeg" target="_blank">
                                MRECW Cultural Club Presents TARANG 2K25 � National Level Cultural Fest on 8th November, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/International-Hackathon-Nov-3-4-2025.jpeg" target="_blank">
                                INTERNATIONAL HACKATHON 2025 on 3rd & 4th November, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/AI-Driven-Drone-Systems-Oct-30-31-2025.jpeg" target="_blank">
                                The IEEE Student Chapter of MRECW presents Two-Day Hands-on Workshop on AI-Driven Drone Systems: Design, Development, and Applications on 30th & 31st October, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/Ethical-Hacking-Workshop-Oct-28-29-2025.jpeg" target="_blank">
                                CSI Student Chapter - Cyber Security Club (Code Defender) Presents Two-Day Hands-on Workshop on ETHICAL HACKING on 28th & 29th October, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/IEEE-Xplore-Webinar-Oct-27-2025.jpeg" target="_blank">
                                R&D Cell Presents Faculty Webinar on "Accelerating Research Excellence with IEEE Xplore" on 27th October, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/Mock-Drive-Oct-25-2025.jpeg" target="_blank">
                                Training and Placement Cell Presents Mock Drive on 25th October, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/DevOps-Workshop-Oct-23-2025.jpeg" target="_blank">
                                One Day Workshop on �DevOps� for III B.Tech CSE Students on 23rd October, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/Robotics-Workshop-Oct-17-18-2025.jpeg" target="_blank">
                                Two Days Hands-on Workshops on ROBOTICS on 17th & 18th October, 2025.
                            </a>
                        </li>

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="../assets/events/Google-Programme.png" target="_blank">
                                Google Interaction Programme with IV & III B.Tech Students on 15th October, 2025.
                            </a>
                        </li>
                        {/* Add more announcements here */}
                    </ul>
                </div>
                <div className="announcement-footer  text-center" style={{ backgroundColor: "#1d3243 " }}>
                    <a href="#" className="d-block p-2 font-weight-bold text-white text-decoration-none">
                        View All
                    </a>
                </div >
            </div >
        </>
    );
};

export default AnnouncementBox;
